import { useNavigate } from "react-router-dom";

export default function WishlistModal({ onClose }) {
  const navigate=useNavigate();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="w-[265px] h-[210px] md:h-[230px] rounded-[20px] bg-white shadow-lg text-center p-5 relative">

        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 text-lg md:text-xl xl:text-2xl font-bold">×</button>

        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-gradient-to-tr from-pink-400 to-purple-300 flex items-center justify-center">
          <span className="text-white text-2xl">🚀</span>
        </div>
        <p className="text-xs md:text-sm xl:text-base font-medium text-gray-800 mb-3">Item move to Wish List!<br />Please check your Wish List</p>
        <button className="mt-4 bg-[#A63F40] text-white px-4 py-2 rounded text-xs md:text-sm xl:text-base hover:bg-[#7c2a2b]" 
        onClick={()=>{navigate("/wishlistpage");onClose();}}>
          Go To Wishlist
        </button>
      </div>
    </div>
  );
}
